"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gravedona-ed-uniti": {
    "ff1f2dde": [{
      "hkey": "4c294d68",
      "slug": "gravedona-ed-uniti",
      "name": "Gravedona ed Uniti",
      "primary": true,
      "skipSearch": false
    }],
    "negrana": [{
      "hkey": "4c294d68",
      "slug": "gravedona-ed-uniti",
      "name": "Gravedona ed Uniti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "da8a0bb5": [{
      "hkey": "7311f75f",
      "slug": "gravedona",
      "name": "Gravedona",
      "primary": true,
      "skipSearch": false
    }],
    "san-carlo": [{
      "hkey": "7311f75f",
      "slug": "gravedona",
      "name": "Gravedona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;